import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	maxWidth,
	minWidth,
	Text,
	TextButton,
	units,
} from '@calm-web/design-system';

import PriceTagSvg from 'icons/price-tag.svg';

export const PlanPreviewWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	background: ${palette('white')};
	align-items: center;
	border-radius: 4px;
	padding: 6px 16px;
	margin-top: ${units(6)};

	${maxWidth('desktop')} {
		// For tablet and mobile view
		padding: ${units(2)} ${units(3)};
		line-height: 30px;
		letter-spacing: 0.17px;
		flex-direction: column;
		margin-top: ${units(3)};
	}
`;

export const EditCoveredLivesText = styled(Text).attrs({
	weight: FontWeights.Demi,
	color: 'text',
	el: 'span',
})<{ isTextBody?: boolean }>`
	${maxWidth('desktop')} {
		// For tablet and mobile view
		${fontSize(FontSizes.base)};
		${props => (props.isTextBody ? fontWeight(FontWeights.Medium) : fontWeight(FontWeights.Demi))};
	}
	${minWidth('desktop')} {
		${fontSize(FontSizes.sm)};
	}
`;

export const EditButton = styled(TextButton).attrs({
	hideUnderline: true,
	size: FontSizes.sm,
})`
	${fontWeight(FontWeights.Demi)};
	margin-left: ${units(6)};

	${maxWidth('desktop')} {
		// For tablet and mobile view
		margin-left: 0;
		${fontSize(FontSizes.base)};
	}
`;

export const PriceTagIcon = styled(PriceTagSvg)`
	margin-right: ${units(2)};
`;
